<template>
  <el-form-item
    :key="form.key"
    :label="form.cname+':'"
    :prop="prop"
    :rules="rule">
    <el-select
      v-if="status === 'edit'"
      v-model="form.fieldValue"
      style="width: 100%"
      multiple
      placeholder="">
      <el-option
        v-for="sitem in list"
        :key="sitem.certId"
        :label="sitem.certName"
        :value="sitem.certId">
      </el-option>
      <el-option :value="null">
        <el-button
          type="primary"
          style="width: 100%"
          @click.stop="create">新增</el-button>
      </el-option>
    </el-select>
    <span v-else>{{ name }}</span>
    <certificate-modal
      ref="modal"
      :vendorId="vendorId"
      :fetch="fetchList" />
  </el-form-item>
</template>

<script>
import CertificateModal from '@/page/certificate/certificate-modal.vue'
export default {
  name: 'CertFormSelect',
  components: { CertificateModal },
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    },
    vendorId: [String, Number]
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    form: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    name() {
      const names = this.list.filter(o => this.form.fieldValue.indexOf(o.certId) > -1)
      return names.map(o => o.certName).join('，')
    },
    rule() {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'change'
        }
      ]
    }
  },
  watch: {
    vendorId: {
      handler(val) {
        if (val) {
          this.fetchList()
        }
      },
      immediate: true
    }
  },
  methods: {
    create() {
      this.$refs.modal.toggleModal(true)
    },
    fetchList() {
      this.$store.dispatch('certificate/getcertificates', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          status: 3,
          vendorId: this.vendorId
        },
        success: (res) => {
          this.list = res.data.records.map(item => {
            item.certFile = item.certFile.split(',')[0]
            return item
          })
        },
        fail: () => { }
      })
    }
  }
}
</script>
